<template>
  <div class="hotline-number">
    <svg v-if="blackmode == 'true'" version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511.8 67" style="enable-background:new 0 0 511.8 67;" xml:space="preserve">
      <g>
        <defs>
          <rect id="SVGID_1_" y="-774.9" width="595.3" height="28.3"/>
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
        </clipPath>
        <g style="clip-path:url(#SVGID_2_);">
          <text transform="matrix(1 0 0 1 121.8936 -746.9442)" style="font-family:'Helvetica'; font-size:12px;"> </text>
        </g>
        
          <line style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:0.85;stroke-linecap:square;stroke-miterlimit:10;" x1="28.4" y1="-746.6" x2="566.9" y2="-746.6"/>
      </g>
      <g>
        <defs>
          <rect id="SVGID_3_" y="0" width="511.8" height="67"/>
        </defs>
        <clipPath id="SVGID_4_">
          <use xlink:href="#SVGID_3_"  style="overflow:visible;"/>
        </clipPath>
        <g style="clip-path:url(#SVGID_4_);">
          <defs>
            <rect id="SVGID_5_" y="0" width="511.8" height="67"/>
          </defs>
          <clipPath id="SVGID_6_">
            <use xlink:href="#SVGID_5_"  style="overflow:visible;"/>
          </clipPath>
          <rect y="6.6" style="clip-path:url(#SVGID_6_);fill:#FFFFFF;" width="511.8" height="53.9"/>
          <path style="clip-path:url(#SVGID_6_);fill:#1D1D1B;" d="M1.5,8.1h508.8v50.9H1.5V8.1z M0,60.4h511.8V6.6H0V60.4z"/>
          <polygon style="clip-path:url(#SVGID_6_);fill:#1D1D1B;" points="278.3,5.1 278.3,19.2 292.6,33.5 278.3,47.8 278.3,61.8 
            498.6,61.8 498.6,5.1 		"/>
          <g style="clip-path:url(#SVGID_6_);">
            <defs>
              <rect id="SVGID_7_" y="0" width="511.8" height="67"/>
            </defs>
            <clipPath id="SVGID_8_">
              <use xlink:href="#SVGID_7_"  style="overflow:visible;"/>
            </clipPath>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M299.6,16.9c0-3.2,1.7-4.1,3.9-4.2c2.1,0,4.5,0.3,5.6,0.6v2.4
              c-1.3-0.1-4.1-0.2-4.8-0.2c-1.2,0-1.9,0.1-1.9,1.6v0.8c0,1.3,0.4,1.6,1.6,1.6h2.3c2.8,0,3.4,2.5,3.4,4.3v1.1c0,3.7-2.1,4.3-4,4.3
              c-2.5,0-4.1-0.2-5.6-0.7V26c0.8,0.1,3.2,0.2,5,0.2c0.8,0,1.8-0.2,1.8-1.4V24c0-0.9-0.2-1.5-1.3-1.5h-2.2c-3.5,0-3.7-2.9-3.7-4.3
              V16.9z"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M315.7,17.2c3,0,4.5,0.4,4.5,4.3c0,2.1-1,2.9-2.9,2.9h-3.3
              c0,2.1,0.7,2.2,2.2,2.2c1.6,0,2.4,0,3.9-0.2v2.1c-1.5,0.6-3.7,0.6-5.4,0.6c-2.7,0-3.5-1.7-3.5-6C311.1,18,312.3,17.2,315.7,17.2
              M316.5,22.1c0.6,0,0.9-0.3,0.9-0.9c0-1.5-0.2-1.7-1.5-1.7c-1.5,0-2,0.1-2,2.6H316.5z"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M321.6,17.3h2.3l0.4,1.5c0.7-0.8,1.7-1.6,3-1.6c0.5,0,0.9,0,1.2,0.1v3
              c-0.3,0-0.9-0.1-1.5-0.1c-1.1,0-2,0.2-2.7,1.3v7.5h-2.8V17.3z"/>
            <polygon style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" points="332.2,17.3 334.5,25.3 336.9,17.3 339.9,17.3 336,28.9 
              332.9,28.9 329.3,17.3 			"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M340.9,13.6c0-0.3,0.2-0.5,0.5-0.5h2.1c0.3,0,0.4,0.2,0.4,0.5v2
              c0,0.3-0.2,0.5-0.4,0.5h-2.1c-0.3,0-0.5-0.2-0.5-0.5V13.6z M341,17.3h2.8v11.7H341V17.3z"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M348.8,17.1c1,0,3.1,0.1,4.8,0.7v1.9c0,0-1.9-0.1-3.7-0.1
              c-1.3,0-1.9,0.1-1.9,3.5c0,3,0.5,3.4,1.9,3.4c1.8,0,3.8-0.2,3.8-0.2v1.9c-1.5,0.9-3.3,0.7-5,0.7c-2,0-3.5-1.1-3.5-6
              C345.4,18.3,346.8,17.1,348.8,17.1"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M359.4,17.2c3,0,4.5,0.4,4.5,4.3c0,2.1-1,2.9-2.9,2.9h-3.3
              c0,2.1,0.7,2.2,2.2,2.2c1.6,0,2.4,0,3.9-0.2v2.1c-1.5,0.6-3.7,0.6-5.4,0.6c-2.7,0-3.5-1.7-3.5-6C354.8,18,356,17.2,359.4,17.2
              M360.2,22.1c0.6,0,0.9-0.3,0.9-0.9c0-1.5-0.2-1.7-1.5-1.7c-1.5,0-2,0.1-2,2.6H360.2z"/>
            <polygon style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" points="299.3,42.2 302.2,42.2 302.2,38.9 304.6,38.9 304.6,42.2 
              307.5,42.2 307.5,44.8 304.6,44.8 304.6,48.1 302.2,48.1 302.2,44.8 299.3,44.8 			"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M314.1,39.6h2.3l0.5,1.2c0.7-0.6,1.9-1.3,3.2-1.3c2.6,0,3.4,2.4,3.4,5.9
              c0,3.4-0.5,6.1-3.4,6.1c-0.9,0-2.2-0.3-3.2-0.8v6.5h-2.8V39.6z M319.3,49.1c0.9,0,1.4-0.6,1.4-3.5c0-2.6-0.5-3.4-1.4-3.4
              c-1,0-1.9,0.3-2.5,0.7v5.8C317.5,49,318.3,49.1,319.3,49.1"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M325.1,39.6h2.3l0.4,1.5c0.7-0.8,1.7-1.6,3-1.6c0.5,0,0.9,0,1.2,0.1v3
              c-0.3,0-0.9-0.1-1.5-0.1c-1.1,0-2,0.2-2.7,1.3v7.5h-2.8V39.6z"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M333.2,36c0-0.3,0.2-0.6,0.5-0.6h2.1c0.3,0,0.4,0.2,0.4,0.6v1.9
              c0,0.3-0.2,0.5-0.4,0.5h-2.1c-0.3,0-0.5-0.2-0.5-0.5V36z M333.3,39.6h2.8v11.7h-2.8V39.6z"/>
            <polygon style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" points="340.9,45.5 337.3,39.6 340.6,39.6 342.5,43.1 344.5,39.6 
              347.9,39.6 344.2,45.5 347.7,51.3 344.5,51.3 342.6,47.9 340.6,51.3 337.3,51.3 			"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M353.8,47.2c0-1.7,0.8-3.2,3.1-3.2c0,0,3.1,0,3.1,0c0,0,0-0.7,0-0.7
              c0-1.2-0.5-1.4-1.4-1.4c-0.9,0-3.6,0.2-4.4,0.3v-1.9c1.4-0.6,2.8-0.8,4.8-0.8c2.3,0,3.8,0.9,3.8,3.8v8.2h-2.2l-0.6-1.3
              c-0.1,0.3-1.6,1.5-3.2,1.4c-2-0.1-3-1.6-3-3.1V47.2z M357.5,49c1.2,0,2.4-0.9,2.4-0.9v-2.1l-2.5,0.2c-0.7,0.1-0.9,0.7-0.9,1.2
              v0.6C356.6,48.9,357,49,357.5,49"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M364.4,39.6h2.3l0.5,1.2c0.7-0.6,1.9-1.3,3.2-1.3c2.6,0,3.4,2.4,3.4,5.9
              c0,3.4-0.5,6.1-3.4,6.1c-0.9,0-2.2-0.3-3.2-0.8v6.5h-2.8V39.6z M369.6,49.1c0.9,0,1.4-0.6,1.4-3.5c0-2.6-0.5-3.4-1.4-3.4
              c-1,0-1.9,0.3-2.5,0.7v5.8C367.9,49,368.6,49.1,369.6,49.1"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M375.4,39.6h2.3l0.5,1.2c0.7-0.6,1.9-1.3,3.2-1.3c2.6,0,3.4,2.4,3.4,5.9
              c0,3.4-0.5,6.1-3.4,6.1c-0.9,0-2.2-0.3-3.2-0.8v6.5h-2.8V39.6z M380.6,49.1c0.9,0,1.4-0.6,1.4-3.5c0-2.6-0.5-3.4-1.4-3.4
              c-1,0-1.9,0.3-2.5,0.7v5.8C378.9,49,379.6,49.1,380.6,49.1"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M390.8,39.6c3,0,4.5,0.4,4.5,4.3c0,2.1-1,2.9-2.9,2.9H389
              c0,2.1,0.7,2.2,2.2,2.2c1.6,0,2.4,0,3.9-0.2v2.1c-1.5,0.6-3.7,0.6-5.4,0.6c-2.7,0-3.5-1.7-3.5-6
              C386.2,40.4,387.5,39.6,390.8,39.6 M391.6,44.5c0.6,0,0.9-0.3,0.9-0.9c0-1.5-0.2-1.7-1.5-1.7c-1.5,0-2,0.1-2,2.6H391.6z"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M396.8,34.1h2.8v12.6c0,1.7,0.4,2.1,0.9,2.3c0,0,1.2,0.5,1.3,0.5v1.9
              h-2.3c-1.7,0-2.7-1.1-2.7-4.2V34.1z"/>
          </g>
          <g style="clip-path:url(#SVGID_6_);">
            <text transform="matrix(1 0 0 1 369.5127 29.105)" style="fill:#FFFFFF; font-family:'Arial-BoldMT', Arial, sans-serif; font-weight: bold; font-size:22px;">{{ price }} €</text>
          </g>
          <g style="clip-path:url(#SVGID_6_);">
            <text transform="matrix(1 0 0 1.3333 430.6787 29.105)" style="fill:#FFFFFF; font-family:'Arial-BoldMT', Arial, sans-serif; font-weight: bold; font-size:16.5px;"> / appel</text>
          </g>
        </g>
      </g>
      <text transform="matrix(1 0 0 1 11.0176 47.3399)" style="fill:#1D1D1B; font-family:'Arial-BoldMT', Arial, sans-serif; font-weight: bold; font-size:40px;">{{ tel }}</text>
    </svg>

    <svg v-else version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511.8 67" style="enable-background:new 0 0 511.8 67;" xml:space="preserve">
      <g>
        <defs>
          <rect id="SVGID_1_" y="-774.9" width="595.3" height="28.3"/>
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
        </clipPath>
        <g style="clip-path:url(#SVGID_2_);">
          <text transform="matrix(1 0 0 1 121.8936 -746.9442)" style="font-family:'Helvetica'; font-size:12px;"> </text>
        </g>
        
          <line style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:0.85;stroke-linecap:square;stroke-miterlimit:10;" x1="28.4" y1="-746.6" x2="566.9" y2="-746.6"/>
      </g>
      <g>
        <defs>
          <rect id="SVGID_3_" y="0" width="511.8" height="67"/>
        </defs>
        <clipPath id="SVGID_4_">
          <use xlink:href="#SVGID_3_"  style="overflow:visible;"/>
        </clipPath>
        <g style="clip-path:url(#SVGID_4_);">
          <defs>
            <rect id="SVGID_5_" y="0" width="511.8" height="67"/>
          </defs>
          <clipPath id="SVGID_6_">
            <use xlink:href="#SVGID_5_"  style="overflow:visible;"/>
          </clipPath>
          <rect y="6.6" style="clip-path:url(#SVGID_6_);fill:#FFFFFF;" width="511.8" height="53.9"/>
          <path style="clip-path:url(#SVGID_6_);fill:#B2B2B2;" d="M1.5,8.1h508.8v50.9H1.5V8.1z M0,60.4h511.8V6.6H0V60.4z"/>
          <polygon style="clip-path:url(#SVGID_6_);fill:#A31077;" points="278.3,5.1 278.3,19.2 292.6,33.5 278.3,47.8 278.3,61.8 
            498.6,61.8 498.6,5.1 		"/>
          <g style="clip-path:url(#SVGID_6_);">
            <defs>
              <rect id="SVGID_7_" y="0" width="511.8" height="67"/>
            </defs>
            <clipPath id="SVGID_8_">
              <use xlink:href="#SVGID_7_"  style="overflow:visible;"/>
            </clipPath>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M299.6,16.9c0-3.2,1.7-4.1,3.9-4.2c2.1,0,4.5,0.3,5.6,0.6v2.4
              c-1.3-0.1-4.1-0.2-4.8-0.2c-1.2,0-1.9,0.1-1.9,1.6v0.8c0,1.3,0.4,1.6,1.6,1.6h2.3c2.8,0,3.4,2.5,3.4,4.3v1.1c0,3.7-2.1,4.3-4,4.3
              c-2.5,0-4.1-0.2-5.6-0.7V26c0.8,0.1,3.2,0.2,5,0.2c0.8,0,1.8-0.2,1.8-1.4V24c0-0.9-0.2-1.5-1.3-1.5h-2.2c-3.5,0-3.7-2.9-3.7-4.3
              V16.9z"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M315.7,17.2c3,0,4.5,0.4,4.5,4.3c0,2.1-1,2.9-2.9,2.9h-3.3
              c0,2.1,0.7,2.2,2.2,2.2c1.6,0,2.4,0,3.9-0.2v2.1c-1.5,0.6-3.7,0.6-5.4,0.6c-2.7,0-3.5-1.7-3.5-6C311.1,18,312.3,17.2,315.7,17.2
              M316.5,22.1c0.6,0,0.9-0.3,0.9-0.9c0-1.5-0.2-1.7-1.5-1.7c-1.5,0-2,0.1-2,2.6H316.5z"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M321.6,17.3h2.3l0.4,1.5c0.7-0.8,1.7-1.6,3-1.6c0.5,0,0.9,0,1.2,0.1v3
              c-0.3,0-0.9-0.1-1.5-0.1c-1.1,0-2,0.2-2.7,1.3v7.5h-2.8V17.3z"/>
            <polygon style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" points="332.2,17.3 334.5,25.3 336.9,17.3 339.9,17.3 336,28.9 
              332.9,28.9 329.3,17.3 			"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M340.9,13.6c0-0.3,0.2-0.5,0.5-0.5h2.1c0.3,0,0.4,0.2,0.4,0.5v2
              c0,0.3-0.2,0.5-0.4,0.5h-2.1c-0.3,0-0.5-0.2-0.5-0.5V13.6z M341,17.3h2.8v11.7H341V17.3z"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M348.8,17.1c1,0,3.1,0.1,4.8,0.7v1.9c0,0-1.9-0.1-3.7-0.1
              c-1.3,0-1.9,0.1-1.9,3.5c0,3,0.5,3.4,1.9,3.4c1.8,0,3.8-0.2,3.8-0.2v1.9c-1.5,0.9-3.3,0.7-5,0.7c-2,0-3.5-1.1-3.5-6
              C345.4,18.3,346.8,17.1,348.8,17.1"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M359.4,17.2c3,0,4.5,0.4,4.5,4.3c0,2.1-1,2.9-2.9,2.9h-3.3
              c0,2.1,0.7,2.2,2.2,2.2c1.6,0,2.4,0,3.9-0.2v2.1c-1.5,0.6-3.7,0.6-5.4,0.6c-2.7,0-3.5-1.7-3.5-6C354.8,18,356,17.2,359.4,17.2
              M360.2,22.1c0.6,0,0.9-0.3,0.9-0.9c0-1.5-0.2-1.7-1.5-1.7c-1.5,0-2,0.1-2,2.6H360.2z"/>
            <polygon style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" points="299.3,42.2 302.2,42.2 302.2,38.9 304.6,38.9 304.6,42.2 
              307.5,42.2 307.5,44.8 304.6,44.8 304.6,48.1 302.2,48.1 302.2,44.8 299.3,44.8 			"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M314.1,39.6h2.3l0.5,1.2c0.7-0.6,1.9-1.3,3.2-1.3c2.6,0,3.4,2.4,3.4,5.9
              c0,3.4-0.5,6.1-3.4,6.1c-0.9,0-2.2-0.3-3.2-0.8v6.5h-2.8V39.6z M319.3,49.1c0.9,0,1.4-0.6,1.4-3.5c0-2.6-0.5-3.4-1.4-3.4
              c-1,0-1.9,0.3-2.5,0.7v5.8C317.5,49,318.3,49.1,319.3,49.1"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M325.1,39.6h2.3l0.4,1.5c0.7-0.8,1.7-1.6,3-1.6c0.5,0,0.9,0,1.2,0.1v3
              c-0.3,0-0.9-0.1-1.5-0.1c-1.1,0-2,0.2-2.7,1.3v7.5h-2.8V39.6z"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M333.2,36c0-0.3,0.2-0.6,0.5-0.6h2.1c0.3,0,0.4,0.2,0.4,0.6v1.9
              c0,0.3-0.2,0.5-0.4,0.5h-2.1c-0.3,0-0.5-0.2-0.5-0.5V36z M333.3,39.6h2.8v11.7h-2.8V39.6z"/>
            <polygon style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" points="340.9,45.5 337.3,39.6 340.6,39.6 342.5,43.1 344.5,39.6 
              347.9,39.6 344.2,45.5 347.7,51.3 344.5,51.3 342.6,47.9 340.6,51.3 337.3,51.3 			"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M353.8,47.2c0-1.7,0.8-3.2,3.1-3.2c0,0,3.1,0,3.1,0c0,0,0-0.7,0-0.7
              c0-1.2-0.5-1.4-1.4-1.4c-0.9,0-3.6,0.2-4.4,0.3v-1.9c1.4-0.6,2.8-0.8,4.8-0.8c2.3,0,3.8,0.9,3.8,3.8v8.2h-2.2l-0.6-1.3
              c-0.1,0.3-1.6,1.5-3.2,1.4c-2-0.1-3-1.6-3-3.1V47.2z M357.5,49c1.2,0,2.4-0.9,2.4-0.9v-2.1l-2.5,0.2c-0.7,0.1-0.9,0.7-0.9,1.2
              v0.6C356.6,48.9,357,49,357.5,49"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M364.4,39.6h2.3l0.5,1.2c0.7-0.6,1.9-1.3,3.2-1.3c2.6,0,3.4,2.4,3.4,5.9
              c0,3.4-0.5,6.1-3.4,6.1c-0.9,0-2.2-0.3-3.2-0.8v6.5h-2.8V39.6z M369.6,49.1c0.9,0,1.4-0.6,1.4-3.5c0-2.6-0.5-3.4-1.4-3.4
              c-1,0-1.9,0.3-2.5,0.7v5.8C367.9,49,368.6,49.1,369.6,49.1"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M375.4,39.6h2.3l0.5,1.2c0.7-0.6,1.9-1.3,3.2-1.3c2.6,0,3.4,2.4,3.4,5.9
              c0,3.4-0.5,6.1-3.4,6.1c-0.9,0-2.2-0.3-3.2-0.8v6.5h-2.8V39.6z M380.6,49.1c0.9,0,1.4-0.6,1.4-3.5c0-2.6-0.5-3.4-1.4-3.4
              c-1,0-1.9,0.3-2.5,0.7v5.8C378.9,49,379.6,49.1,380.6,49.1"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M390.8,39.6c3,0,4.5,0.4,4.5,4.3c0,2.1-1,2.9-2.9,2.9H389
              c0,2.1,0.7,2.2,2.2,2.2c1.6,0,2.4,0,3.9-0.2v2.1c-1.5,0.6-3.7,0.6-5.4,0.6c-2.7,0-3.5-1.7-3.5-6
              C386.2,40.4,387.5,39.6,390.8,39.6 M391.6,44.5c0.6,0,0.9-0.3,0.9-0.9c0-1.5-0.2-1.7-1.5-1.7c-1.5,0-2,0.1-2,2.6H391.6z"/>
            <path style="clip-path:url(#SVGID_8_);fill:#FFFFFF;" d="M396.8,34.1h2.8v12.6c0,1.7,0.4,2.1,0.9,2.3c0,0,1.2,0.5,1.3,0.5v1.9
              h-2.3c-1.7,0-2.7-1.1-2.7-4.2V34.1z"/>
          </g>
          <g style="clip-path:url(#SVGID_6_);">
            <text transform="matrix(1 0 0 1 369.5127 29.105)" style="fill:#FFFFFF; font-family:'Arial-BoldMT', Arial, sans-serif; font-weight: bold; font-size:22px;">{{ price }} €</text>
          </g>
          <g style="clip-path:url(#SVGID_6_);">
            <text transform="matrix(1 0 0 1.3333 430.6787 29.105)" style="fill:#FFFFFF; font-family:'Arial-BoldMT', Arial, sans-serif; font-weight: bold; font-size:16.5px;"> / appel</text>
          </g>
        </g>
      </g>
      <text transform="matrix(1 0 0 1 11.0176 47.3399)" style="fill:#A31077; font-family:'Arial-BoldMT', Arial, sans-serif; font-weight: bold; font-size:40px;">{{ tel }}</text>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'HotlineNumber',
    props: {
      blackmode: {
        type: String,
        default: 'false',
        validator: function(value) {
          if(value == 'true' || value == 'false') {
            return true
          } else {
            throw new Error('Error: prop [blackmode] must be a String boolean like: "true" of "false"')
          }
        }
      },
      price: {
        type: String,
        default: '0,12'
      },
      tel: {
        type: String,
        required: true,
        default: '0 810 000 000',
        validator: function (value) {
          if(value.split(' ').length == 4 && value.length == 13 || value.split(' ').length == 5 && value.length == 14) {
            return true
          } else {
            throw new Error('Error: prop [tel] must be formated like: "0 810 000 000" or "0 810 00 00 00" or "08 10 00 00 00"')
          }
        }
      }
    }
  }
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
  }
  .hotline-number {
    height: 40px;
    width: 100%;
    pointer-events: none;
  }
</style>